import { GenericBanner } from "@/components/GenericBanner";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import animationData from "@/assets/animations/It_Works_Drawing_03_No_Loop.json";
import { JobSearchField } from "@/components/JobSearchField";

export default function Banner({ className, title }) {
  return (
    <GenericBanner className={className} animationData={animationData} title={title}>
      <JobSearchField />
      <Breadcrumbs className="mt-5 pt-3" disabled={["podcasts", "news"]} />
    </GenericBanner>
  );
}
